module.exports = __webpack_public_path__ + "static/media/09 REGGIANA CALCIO Heysel.c6f757fb.svg";